import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type OrganisationRecord = ResultOf<
  typeof organisationRecordQuery
>["organisation"];
export const organisationRecordQuery = graphql(`
  query OrganisationRecord($id: ID!) {
    organisation(id: $id) {
      ...OrganisationFields
    }
  }
`);

graphql(`
  fragment OrganisationFields on Organisation {
    __typename
    id
    name
    is_verified
    salesAgent {
      id
      name
    }

    featureFlags {
      type
      created_at
    }

    profilePicture {
      ...MediaFields
    }
    contact {
      ...ContactRecordFields
    }
    last_relocation_created_at
    created_at
    updated_at
  }
`);
